import React from "react"
import classnames from "classnames"
import { WINDOW, IS_IE, IS_EDGE } from "AtomicUtils/environment"
import styles from "./Tabs.less"
import { A , Interactive } from "AtomicComponents"
import debounce from 'AtomicUtils/debounce'

class Tabs extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      activeIndex: props.activeIndex || props.active,
      calculated: false,
      justifyContent: 'center',
      isIE: false
    }
    this.tabs = null
    this.tabsUL = null
  }

  componentDidMount() {
    const { activeIndex, scrolling, active } = this.props
    this.setState({
      isIE: IS_IE || IS_EDGE
    }, () => {
      this._handleClick(activeIndex || active || 0, false)
    })
    if (scrolling) {
      setTimeout(() => {
        this._setDimension()
        WINDOW.addEventListener("resize", debounce(this._setDimension, 250))
      }, 250);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let newActive = this.state.activeIndex
    if ( typeof this.props.active !== "undefined" ) {
      newActive = Number(this.props.active)
    } else if ( typeof this.props.activeIndex !== "undefined" ) {
      newActive = Number(this.props.activeIndex)
    }
    const oldActive = Number(prevState.activeIndex)

    if (!isNaN(newActive) && !isNaN(oldActive) && newActive !== oldActive){
      this._handleClick(newActive, false)
    }
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("resize", debounce(this._setDimension,250));
  }

  _setDimension = () => {
    if (this.tabsUL && this.tabsUL.scrollWidth <= this.tabs.offsetWidth) {
      this.setState({
        justifyContent: 'center',
        calculated: true
      })
    } else {
      this.setState({
        justifyContent: 'left',
        calculated: true
      })
      if (this.tabsUL){
        this.tabsUL.style.marginLeft = `0px`
      }
    }
  }

  _handleClick = (activeIndex, callOnClickOfParent = true) => {
    const { onClick = () => {}, scrolling, manualScroll } = this.props
    const { isIE } = this.state
    const shouldScroll = activeIndex !== this.state.activeIndex

    this.setState({
      activeIndex: Number(activeIndex)
    }, () => {
      if (callOnClickOfParent)
        onClick(activeIndex)

      // handling scrolling tor right if scrolling is enabled
      if (scrolling && this.tabs && this.tabsUL && this.tabsUL.children && this.tabsUL.children.length && shouldScroll) {
        const unitSize = this.tabsUL.children[activeIndex].offsetWidth
        const maxMarginLeftPossible = this.tabsUL.scrollWidth - this.tabs.offsetWidth
        const currentMarginLeft = Number(this.tabsUL.style.marginLeft.replace('px','')) * -1
        const unitScrollLeft = this.tabsUL.children[activeIndex].offsetLeft
        const centerMargin = (this.tabs.offsetWidth - unitSize) / 2

        if (this.tabsUL.children[activeIndex]) {
          if (unitScrollLeft < centerMargin) {
            this.tabsUL.style.marginLeft = `-${Math.max(0, currentMarginLeft - centerMargin)}px`
          } else if (unitScrollLeft > (centerMargin + unitSize)) {
              this.tabsUL.style.marginLeft = `-${Math.min(maxMarginLeftPossible, currentMarginLeft + centerMargin)}px`
          }
        }
      }

      // Smooth scrolling does not work on IE (and is not needed as well)
      if (manualScroll && !isIE && this.tabs && this.tabsUL && this.tabsUL.children && this.tabsUL.children.length && shouldScroll) {
        const unitSize = this.tabsUL.children[activeIndex].offsetWidth
        const unitScrollLeft = this.tabsUL.children[activeIndex].offsetLeft
        const currentScrollLeft = this.tabs.scrollLeft

        if (this.tabsUL.children[activeIndex]) {
          if (unitScrollLeft < currentScrollLeft) {
            this.tabs.scroll({ left: unitScrollLeft - 75, behavior: 'smooth' })
          } else if ((unitScrollLeft + unitSize) > (currentScrollLeft + this.tabs.offsetWidth)) {
            this.tabs.scroll({ left: unitScrollLeft + unitSize - this.tabs.offsetWidth + 75, behavior: 'smooth' })
          }
        }
      }
    })
  }

  render() {
    // animatedLine is the redline!
    const {
      options,
      animatedLine = false,
      activeLineOnly = false,
      divider = false,
      scrolling,
      manualScroll = false,
      children,
      numberOfWrappedItems,
      limited = true
    } = this.props

    let model = 0 // means options and 1 means read children

    if (options && options.length > 0) model = 0
    else if (children && children.length > 0) model = 1

    const tabItems = model === 1 ? children : options

    const {
      activeIndex,
      calculated,
      justifyContent
    } = this.state

    let liStyle = {}
    if (numberOfWrappedItems && numberOfWrappedItems > 1) {
      liStyle = {
        minWidth: `${100/numberOfWrappedItems}%`
      }
    }

    return (
      <div
      ref={c => this.tabs = c}
      className={classnames({
        [styles.Tabs]: true,
        [styles.TabsScrolling]: scrolling,
        [styles.TabsManualScroll]: manualScroll,
        [styles.TabsScrollingCenter]: justifyContent === 'center',
        [styles.TabsScrollingCalculated]: calculated
      })}>
        <ul
          ref={c => this.tabsUL = c}
          data-test="tabs"
          className={classnames({
            [styles.TabsUL]: true
          })}>
          {tabItems && tabItems.length > 0 && tabItems.map((item,index) => {
            if (model === 0 && !item.name) return
            return (
              <li
                key={`Tabs-${index}`}
                data-test="tab-item"
                className={classnames({
                  [styles.TabsLI]: true,
                  [styles.TabsLILimited]: limited && model === 0 && item.name.length > 15
                })}
                style={liStyle}
                >
                <A
                  className={classnames({
                    [styles.Link]: true,
                    [styles.LinkWithChildren]: model === 1,
                    [styles.LinkLine]: animatedLine,
                    [styles.LineLineTransparent]: activeLineOnly,
                    [styles.LinkActive]: index === activeIndex,
                    [styles.IgnoreUppercase]: !!item.ignoreUppercase
                  })}
                  onClick={(element) => { this._handleClick(index) }}
                  withoutStyle
                >
                  {model === 0 &&
                    <Interactive
                      withDetails
                    >
                      {item.name}
                    </Interactive>
                  }
                  {model === 1 && item}
                </A>
                {
                  divider && (tabItems.length-1) !== index &&
                  <span className={classnames({
                    [styles.Divider]: true
                  })}> | </span>
                }
                {
                  item.extraLabel && index === activeIndex &&
                  <div className={classnames({
                    [styles.ExtraLabel]: true
                  })}>
                    <span withDetails>
                      {item.extraLabel}
                    </span>
                  </div>
                }
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default Tabs



// WEBPACK FOOTER //
// ./src/AtomicContainers/Tabs/Tabs.jsx